import clarity  from '@microsoft/clarity';
import type { App } from 'vue';
import { EnvironmentService } from '@/services/EnvironmentService';
import { LoggerService } from '@/utils/LoggerService';

const logger = new LoggerService('ClarityPlugin');

export const clarityPlugin = {
  install(app: App) {
    logger.log('install()', app);
    if (EnvironmentService.getClarityProjectId()) {
      // Initialize Clarity
      clarity.init(EnvironmentService.getClarityProjectId());
    }
  }
};